import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router';

import withToggle from '../../hoc/WithToggle';
import CheckoutButton from '../components/CheckoutButton';

export default compose(
  withRouter,
  withToggle,
  lifecycle({
    componentDidUpdate(props) {
      const didTurnToTrue = this.props.toggled === true && props.toggled === false;
      if (didTurnToTrue && this.props.onBeforeOpen) {
        this.props.onBeforeOpen(props);
      }

      const didTurnToFalse = this.props.toggled === false && props.toggled === true;
      if (didTurnToFalse && this.props.onBeforeClose) {
        this.props.onBeforeClose(props);
      }
    },
  })
)(CheckoutButton);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/CheckoutButton.js